<template>
    <el-dialog
        :title="$t('print_basket.title')"
        :visible.sync="visible"
        width="550px"
        :before-close="handleClose"
        append-to-body
    >
        <div style="padding: 0 20px 20px;" v-loading="loading">
            <div v-if="basket && basket.item_count > 0">
                <el-card
                    v-for="(format, index) in basket.formats"
                    :key="index"
                    :body-style="{ padding: '12px 16px' }"
                    style="margin-bottom: 10px;"
                >
                    <el-row style="display: flex; align-items: center;">
                        <el-col :span="16">
                            <div style="font-weight: bold; font-size: 14px;">
                                {{ format.format_title }}
                            </div>
                            <div style="color: #909399; font-size: 12px; margin-top: 4px;">
                                {{ format.prints }} {{ $t('print_basket.prints') }}
                            </div>
                        </el-col>
                        <el-col :span="8" align="right">
                            <el-button
                                type="success"
                                size="mini"
                                icon="el-icon-printer"
                                @click="buildFormat(format.format_id)"
                                :loading="building_format === format.format_id"
                            >
                                {{ $t('print') }}
                            </el-button>
                        </el-col>
                    </el-row>
                </el-card>

            </div>

            <div v-else-if="!loading" style="text-align: center; padding: 40px 0;">
                <i class="fal fa-shopping-basket fa-4x" style="color: #C0C4CC;"></i>
                <h4 style="color: #909399; margin-top: 20px;">
                    {{ $t('print_basket.empty') }}
                </h4>
            </div>
        </div>

        <span slot="footer" style="display: flex; justify-content: space-between;">
            <el-button size="small" @click="handleClose">{{ $t('cancel') }}</el-button>
            <span>
                <el-button
                    type="danger"
                    size="small"
                    icon="el-icon-delete"
                    @click="confirmClear()"
                >
                    {{ $t('print_basket.clear') }}
                </el-button>

                <el-button
                    type="success"
                    size="small"
                    icon="el-icon-printer"
                    @click="buildAll()"
                    :loading="building_all"
                    :disabled="!basket || !basket.formats.length"
                >
                    {{ $t('print_basket.print_all') }}
                </el-button>
            </span>
        </span>

        <handle-print
            ref="basket_print"
            :search_filter="{}"
            :structure="{}"
            :items="[]"
            :list_id="basket ? basket.id : ''"
            :list_title="$t('print_basket.title')"
        >
        </handle-print>
    </el-dialog>
</template>

<script>
import Axios from 'axios';
import HandlePrint from './HandlePrint.vue';

const BASE_URL = 'https://api.brandsafe.no/v2/worklists';

export default {
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            basket: null,
            loading: false,
            building_format: null,
            building_all: false,
            builds: [],
        };
    },

    computed: {
        visible: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        }
    },

    watch: {
        show(val) {
            if (val) {
                this.fetchBasket();
            }
        }
    },

    methods: {
        getToken() {
            return this.$cookies.get('bs_token');
        },

        handleClose() {
            this.visible = false;
        },

        fetchBasket() {
            this.loading = true;

            Axios.get(BASE_URL + '/print-basket', {
                headers: { 'Authorization': 'Bearer ' + this.getToken() }
            }).then(response => {
                this.basket = response.data.data;
                this.loading = false;
                this.$emit('basket-updated', this.basket);
            }).catch(error => {
                console.log(error);
                this.loading = false;
            });
        },

        buildFormat(format_id) {
            this.$refs.basket_print.printAll(false, false, [format_id]);

            setTimeout(() => {
                this.basket.formats = this.basket.formats.filter(f => f.format_id !== format_id);
                this.basket.item_count = this.basket.formats.reduce((sum, f) => sum + f.prints, 0);
                this.basket.total_prints = this.basket.item_count;
                this.$emit('basket-updated', this.basket);

                if (!this.basket.formats.length) {
                    this.handleClose();
                }
            }, 2000);
        },

        buildAll() {
            this.$refs.basket_print.printAll();

            setTimeout(() => {
                this.basket.formats = [];
                this.basket.item_count = 0;
                this.basket.total_prints = 0;
                this.$emit('basket-updated', this.basket);
                this.handleClose();
            }, 2000);
        },

        confirmClear() {
            this.$confirm(
                this.$t('print_basket.clear_confirm'),
                this.$t('messages.warning'),
                {
                    confirmButtonText: this.$t('messages.yes'),
                    cancelButtonText: this.$t('cancel'),
                    type: 'warning'
                }
            ).then(() => {
                Axios.delete(BASE_URL + '/print-basket', {
                    headers: { 'Authorization': 'Bearer ' + this.getToken() }
                }).then(() => {
                    this.basket = { ...this.basket, item_count: 0, total_prints: 0, formats: [] };
                    this.$emit('basket-updated', this.basket);

                    this.$notify({
                        title: this.$t('messages.success'),
                        message: this.$t('print_basket.cleared'),
                        type: 'success'
                    });
                }).catch(error => {
                    console.log(error);
                });
            }).catch(() => {});
        }
    },

    components: {
        HandlePrint
    }
};
</script>
